import { parsePhoneNumber } from 'libphonenumber-js/min';

export const parsePhone = (phone: string) => {
  try {
    const { nationalNumber, country, number } = parsePhoneNumber(phone);

    return {
      phoneNumber: nationalNumber,
      internationalNumber: number,
      countryCode: country,
    };
  } catch (error) {
    console.error('Failed to parse phone number:', error);
  }
};
